/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Featureinteractivetitle2Inputs */

const zh_about_featureinteractivetitle2 = /** @type {(inputs: About_Featureinteractivetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`丰富的互动学习`)
};

const en_about_featureinteractivetitle2 = /** @type {(inputs: About_Featureinteractivetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rich Interactive Learning`)
};

const es_about_featureinteractivetitle2 = /** @type {(inputs: About_Featureinteractivetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprendizaje interactivo rico`)
};

/**
* | output |
* | --- |
* | "Rich Interactive Learning" |
*
* @param {About_Featureinteractivetitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const about_featureinteractivetitle2 = /** @type {((inputs?: About_Featureinteractivetitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Featureinteractivetitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_about_featureinteractivetitle2(inputs)
	if (locale === "en") return en_about_featureinteractivetitle2(inputs)
	return es_about_featureinteractivetitle2(inputs)
});
export { about_featureinteractivetitle2 as "about_featureInteractiveTitle" }